export enum ChartType {
    SleepStages = "sleep-stages",
    SleepStagesProba = "sleep-stages-proba",
    SleepStates = "sleep-states",
    Arousals = "arousals",
    RespiratoryEffort = "respiratory-effort",
    HeadPosition = "head-position",
}
